(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery-categories-images"]) return;
  try {
    

$(document).ready(function() {
	$('.popup-gallery').magnificPopup({
		delegate: 'a',
		type: 'image',
		tLoading: 'Loading image #%curr%...',
		mainClass: 'mfp-img-mobile',
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		},
		image: {
			tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
			titleSrc: function(item) {
				return item.el.attr('title') ;
			}
		}
	});
});  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page__our-works-section"] && !window.DesignMode) return;
  try {
    
(function(){})();

$(function() {
   	$("#tab-slider .meta-category").on('click', function(){
		var __id = $(this).attr('id');

		$('#tab-slider .meta-category.active__tab').removeClass('active__tab');
        $(this).addClass('active__tab');

		$('.Grid-Tab.active__tab').removeClass('active__tab');
		$('#Gallery__'+__id).addClass('active__tab');
		
	});

   	$(".Grid-Tab .view__more").on('click', function(){
		var __parent = $(this).parents('.Grid-Tab');
        var items =  $('.Grid .Grid__Cell', __parent).length;
        var shown =  4;
        shown = $('.Grid .Grid__Cell:visible', __parent).length+3;
        if(shown< items) {
           $('.Grid .Grid__Cell:lt('+shown+')', __parent).css('display', 'inline-block');
        } else {
           $('.Grid .Grid__Cell:lt('+items+')', __parent).css('display', 'inline-block');
        }
	});

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page__section-gallery"]) return;
  try {
    
(function(){})();

$(function() {
	


});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page__section-testimonial-container"] && !window.DesignMode) return;
  try {
    
(function(){
	$('#section-dynamic-testimonial').html( $('.section-preview-testimonial').html()  );	
    $('#featured-review').slick({
      //centerMode: true,
      centerPadding: '60px',
      slidesToShow: 2,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,   
      responsive: [
        {
          breakpoint: 639,
          settings: {
            arrows: true,
            centerPadding: '40px',
            slidesToShow: 1
          }
        }
      ]
    });  
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["request-form"]) return;
  try {
    

window.onload = function() {
    var _form = document.querySelector("form.Form-Catalog");
    _form.onsubmit = submitted.bind(_form);
}

function submitted(_form) {
  	
  	var _type = document.querySelector(".Input_Type").value;
  	localStorage.setItem("request_type", _type);
	_form.submit();
}



  } catch(e) { console.error(e); }
})();
})();
